export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const TOKEN_SENT = "TOKEN_SENT";
export const JOB_OFFER_ACCEPT = "JOB_OFFER_ACCEPT";
export const SET_EXPIRATION_TIME = "SET_EXPIRATION_TIME";
export const IS_LOADING = "IS_LOADING";
export const ALERT_DATA = "ALERT_DATA";
export const SHOW_ALERT = "SHOW_ALERT";
export const SET_FEATURE_FLAGS = "SET_FEATURE_FLAGS";
